// extracted by mini-css-extract-plugin
export var askAiIcon = "_pu-9";
export var container = "_pu-0";
export var groupSeparator = "_pu-a";
export var highlight = "_pu-4";
export var resultIcon = "_pu-5";
export var resultItem = "_pu-7";
export var resultSubtitle = "_pu-3";
export var resultTitle = "_pu-2";
export var resultsList = "_pu-1";
export var searchGroup = "_pu-6";
export var selected = "_pu-8";